// The privacy policy in every UI language.
//
// Deliberately NOT in `@/i18n`: that dictionary is a flat keyset guarded by a parity test,
// and a fourteen-section legal document would drown it. The parity guarantee is kept here
// instead, by `privacy.test.js`, which checks section ids and order against the Italian
// original — the authoritative version.
import it from "./privacy.it";
import en from "./privacy.en";
import es from "./privacy.es";
import fr from "./privacy.fr";
import de from "./privacy.de";
import { AUTHORITATIVE_LANG } from "@/lib/legal";

export const PRIVACY_DOCS = { it, en, es, fr, de };

/** The policy for `lang`, falling back to the authoritative Italian text. */
export function privacyDoc(lang) {
  return PRIVACY_DOCS[lang] || PRIVACY_DOCS[AUTHORITATIVE_LANG];
}

/** SEO title/description for the policy page, per language. */
export const PRIVACY_SEO = {
  it: {
    title: "Informativa sulla privacy — VisioScreening",
    description:
      "Come VisioScreening tratta i dati personali: titolare, finalità, basi giuridiche, conservazione, cookie e diritti. I dati sanitari del lavoratore non lasciano mai il dispositivo del professionista.",
  },
  en: {
    title: "Privacy Policy — VisioScreening",
    description:
      "How VisioScreening processes personal data: controller, purposes, legal bases, retention, cookies and your rights. The worker's health data never leaves the professional's device.",
  },
  es: {
    title: "Política de privacidad — VisioScreening",
    description:
      "Cómo trata VisioScreening los datos personales: responsable, finalidades, bases jurídicas, conservación, cookies y derechos. Los datos sanitarios del trabajador nunca salen del dispositivo del profesional.",
  },
  fr: {
    title: "Politique de confidentialité — VisioScreening",
    description:
      "Comment VisioScreening traite les données personnelles : responsable, finalités, bases légales, conservation, cookies et droits. Les données de santé du travailleur ne quittent jamais l'appareil du professionnel.",
  },
  de: {
    title: "Datenschutzerklärung — VisioScreening",
    description:
      "Wie VisioScreening personenbezogene Daten verarbeitet: Verantwortlicher, Zwecke, Rechtsgrundlagen, Speicherdauer, Cookies und Rechte. Gesundheitsdaten der Arbeitskraft verlassen nie das Gerät der Fachperson.",
  },
};

export function privacySeo(lang) {
  return PRIVACY_SEO[lang] || PRIVACY_SEO[AUTHORITATIVE_LANG];
}
